import { PageLayout } from '../../components/page-layout';
import { ErrorMessage } from '../../components/error-message';
import {
    BACK_TO_START,
    PLEASE_GO_BACK_TO_THE_START_AND_ENTER_YOUR_EMAIL_AGAIN,
    SMS_CODE_HAS_EXPIRED,
} from '../../translator/phrase-keys';
import { LanguageContext } from '../../components/language-settings';
import { useContext } from 'react';

export function TimeoutView({changeView}) {
    const {translator} = useContext(LanguageContext);

    function backToStart() {
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("expires");
        sessionStorage.removeItem("temporary_password");

        changeView("identity");
    }

    return (
        <PageLayout
            image="svg/verify.svg"
            progress="2"
            title={translator.translate(SMS_CODE_HAS_EXPIRED)}
        >
            <ErrorMessage text={translator.translate(PLEASE_GO_BACK_TO_THE_START_AND_ENTER_YOUR_EMAIL_AGAIN)}/>

            <span
                className="page-link"
                onClick={() => backToStart()}
            >
                {translator.translate(BACK_TO_START)}
            </span>
        </PageLayout>
    );
}